import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Row,
  message,
  Select,
  Space,
  Input,
  InputNumber,
} from "antd";

import { reportService, stockReceiptService } from "_services";
import { ReceiptType } from "_helpers";

function TiepAvailableLiabilitySearch(props) {
  const [form] = Form.useForm();

  let dateFilter = false;
  let fromDate = null;
  let toDate = null;

  const onFinish = (values) => {
    props.showSearchLoading(true);
    console.table(values);
    let paramList = [];

    if (values?.customRefNumber) {
      paramList.push(`customRefNumber=${values?.customRefNumber}`);
    }

    if (values?.receiptType) {
      paramList.push(`type=${values?.receiptType}`);
    }

    const searchParams = paramList.length > 0 ? `?${paramList.join("&")}` : "";

    props.onSearchResults(searchParams);
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      className="search-form"
      initialValues={{
        liabilityMin: 0,
        liabilityMax: 0,
      }}
    >
      <Row gutter={24}>
        <Col span={4}>
          <Form.Item name="customRefNumber" label="Cus.Dec.No#">
            <Input placeholder="Input Customs Declaration No." allowClear />
          </Form.Item>
        </Col>

        <Col span={4}>
          <Form.Item name="receiptType" label="Import Type">
            <Select allowClear>
              {ReceiptType.map((item) => (
                <Select.Option value={item.value} key={item.value}>
                  {item.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}></Col>
        <Col span={4}>
          <Space align="center">
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button
              style={{ margin: "0 8px" }}
              onClick={() => {
                form.resetFields();
                onFinish();
              }}
            >
              Clear
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
}

export default TiepAvailableLiabilitySearch;
